export enum SegmentEvents {
    // Visitron Events
    VISITRON_OPENED = 'visitron_opened',
    // General AI Events
    GENAI_CHAT_PAGE_VIEWED = 'genai_chat_page_viewed',
    GENAI_VERCEL_ASSISTANT_CHAT_PAGE_VIEWED = 'genai_vercel_assistant_chat_page_viewed',
    // ID Verification Events
    ID_VERIFICATION_STARTED = 'id_verification_started',
    ID_VERIFICATION_SUCCEEDED = 'id_verification_succeeded',
    ID_VERIFICATION_FAILED = 'id_verification_failed',
    // SKU Page A/B Test Events
    SKU_PAGE_VARIANT = 'sku_page_variant',
    SKU_STICKY_CTA_VARIANT = 'sku_sticky_cta_variant',
    SKU_PAGE_CTA_CLICKED = 'sku_page_cta_clicked',
    // Signup A/B Test Events
    EMAIL_VALIDATION_VARIANT = 'email_validation_variant',
    // In-person visit events
    CLICKED_IN_PERSON_VISIT_CARD = 'clicked_in_person_visit_card',
    // Client Error Events
    CLIENT_ERROR = 'client_error',
    // Customer dashboard 1.0 vs 1.5 rollout (underscores so EVENT_NAME filters stay simple)
    DASHBOARD_1_0_VIEWED = 'dashboard_1_0_viewed',
    DASHBOARD_1_0_DWELL = 'dashboard_1_0_dwell',
    DASHBOARD_1_5_VIEWED = 'dashboard_1_5_viewed',
    DASHBOARD_1_5_DWELL = 'dashboard_1_5_dwell',
    // Message Center
    MESSAGE_CENTER_PAGE_VIEWED = 'message_center_page_viewed',
    MESSAGE_CENTER_CONVERSATION_VIEWED = 'message_center_conversation_viewed',
}

/** Care-plan / next-steps events; names are prefixed by trackNextStepsEvent. */
export enum NextStepsAnalytics {
    LOADED_CARE_PLAN = 'loaded_care_plan',
    PAGE_VIEW_VISIT = 'page_view_visit',
    SCROLLED_IN_VIEW_CARE_PLAN_VISIT = 'scrolled_in_view_care_plan_visit',
    SCROLLED_IN_VIEW_FULLY_CARE_PLAN_VISIT = 'scrolled_in_view_fully_care_plan_visit',
    SCROLLED_IN_VIEW_DASHBOARD_VISIT = 'scrolled_in_view_dashboard_visit',
    CONFIRM_VISIT = 'confirm_visit',
    RESCHEDULE_VISIT = 'reschedule_visit',
    RESCHEDULE_CANCELLED_VISIT = 'reschedule_cancelled_visit',
    CANCEL_VISIT = 'cancel_visit',
    BOOK_LABS = 'book_labs',
    BOOK_LABS_INFO = 'book_labs_info',
    BOOK_FOLLOW_UP_VISIT = 'book_follow_up_visit',
    // Sequential Flow Events
    SEQUENTIAL_CONTINUE_CARE_PLAN_CLICKED = 'sequential_continue_care_plan_clicked',
    SEQUENTIAL_RETURN_TO_CARE_PLAN_CLICKED = 'sequential_return_to_care_plan_clicked',
    SEQUENTIAL_CARE_ITEM_CLICKED = 'sequential_care_item_clicked',
    PATIENT_RATIONALE_FEEDBACK = 'patient_rationale_feedback',
    PATIENT_RATIONALE_VIEWED = 'patient_rationale_viewed',
}

/** Storefront events; names are prefixed by trackStoreEvent. */
export enum StoreAnalytics {
    VIEWED_CATEGORY_PAGE = 'viewed_category_page',
    VIEWED_DETAIL_PAGE = 'viewed_detail_page',
    VIEWED_SEARCH_RESULTS = 'viewed_search_results',
    VIEWED_SEARCH_RESULTS_FAILURE = 'viewed_search_results_failure',
    VIEWED_VISIT_OPTION_PAGE = 'viewed_visit_option_page',
    VIEWED_QUESTIONNAIRE_INTERSTITIAL = 'viewed_questionnaire_interstitial',
    VIEWED_SERVICE_UNAVAILABLE = 'viewed_service_unavailable',
    VIEWED_OFF_RAMP_ERROR = 'viewed_off_ramp_error',
    CLICKED_SKU = 'clicked_sku',
    SCROLLED_CAROUSEL = 'scrolled_carousel',
    SEARCH_START = 'search_start',
    SEARCH_QUERY = 'search_query',
    SUBMITTED_SEARCH = 'submitted_search',
    CLICKED_CATEGORY_GRID = 'clicked_category_grid',
    CLICKED_ADD_INSURANCE = 'clicked_add_insurance',
    GUIDANCE_CLICKED_BOOK_VISIT = 'guidance_clicked_book_visit',
    GUIDANCE_CLICKED_TEXT_US = 'guidance_clicked_text_us',
    TESTIMONIAL = 'testimonial',
    NAV_HEADER_CLICKED = 'nav_header_clicked',
    NAV_HAMBURGER_MENU = 'nav_hamburger_menu',
    CLICKED_BREADCRUMB = 'clicked_breadcrumb',
    CLICKED_CATEGORY_PILL = 'clicked_category_pill',
    CLICKED_FLOATING_TEXT_US = 'clicked_floating_text_us',
    CLICKED_VISIT_OPTION_CARD = 'clicked_visit_option_card',
    CLICKED_OFFICE_VISIT_CARD = 'clicked_office_visit_card',
    BOOKING_AVAILABILITY_DISPLAYED = 'booking_availability_displayed',
    BOOKING_TIME_SLOT_SELECTED = 'booking_time_slot_selected',
    BOOKING_SEE_MORE_TIMES_CLICKED = 'booking_see_more_times_clicked',
    BOOKING_NO_MEDICAID_OPTION = 'booking_no_medicaid_option',
    BOOKING_NO_AVAILABILITY = 'booking_no_availability',
    CHECKOUT_BOOKED_CLICKED = 'checkout_booked_clicked',
    CHECKOUT_START_CC_INPUT = 'checkout_start_cc_input',
    CHECKOUT_ACCEPTED_TERMS = 'checkout_accepted_terms',
    CHECKOUT_PAYMENT_ERROR = 'checkout_payment_error',
    CHECKOUT_VIEWED = 'checkout_viewed',
    CHECKOUT_BOOKED = 'checkout_booked',
}

/** Where in the storefront an event originated. */
export enum PageLocation {
    ACCOUNT = 'account',
    CATEGORY = 'category_page',
    DETAIL_PAGE = 'detail_page',
    SEARCH_RESULTS = 'search_results_page',
    VISIT_OPTION_PAGE = 'visit_option_page',
    BOOKING_PAGE = 'booking_page',
    GENERAL_AI_CHAT = 'general_ai_chat',
}
